import React, { useState } from "react";
import { IconDownload, IconEye, IconPlus, IconSend } from "@tabler/icons-react";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import DropdownFilter from "../../../components/common/DropdownFilter";
import NormalSearch from "../../../components/common/NormalSearch";
import ListView from "../../../components/common/ListView";
import CommonModal from "../../../components/common/CommonModal";
import ToggleButton from "../../../components/ToggleButton";
import AddCompanyModal from "./AddCompanyModal";
import RequestSendModal from "./RequestSendModal";

const lineHaulCompany = [
  {
    id: 1,
    companyName: "Blue Logistics",
    contact: "9856321470",
    email: "bluelogistics@gmail.com",
    address: "20, Street Riyadh",
    date: "4 Aug 2025",
    active: false,
  },
  {
    id: 2,
    companyName: "Blue Logistics",
    contact: "9856321470",
    email: "bluelogistics@gmail.com",
    address: "20, Street Riyadh",
    date: "4 Aug 2025",
    active: true,
  },
  {
    id: 3,
    companyName: "Blue Logistics",
    contact: "9856321470",
    email: "bluelogistics@gmail.com",
    address: "20, Street Riyadh",
    date: "4 Aug 2025",
    active: false,
  },
  {
    id: 4,
    companyName: "Blue Logistics",
    contact: "9856321470",
    email: "bluelogistics@gmail.com",
    address: "20, Street Riyadh",
    date: "4 Aug 2025",
    active: true,
  },
  {
    id: 5,
    companyName: "Blue Logistics",
    contact: "9856321470",
    email: "bluelogistics@gmail.com",
    address: "20, Street Riyadh",
    date: "4 Aug 2025",
    active: true,
  },
];

const LineHaulCompanies: React.FC = () => {
  const [openShelve, setOpenShelve] = useState<boolean>(false);
  const openShelveToggleModal = () => {
    setOpenShelve(!openShelve);
  };
  const [sendRequest, setSendRequest] = useState<boolean>(false);
  const sendRequestToggleModal = () => {
    setSendRequest(!sendRequest);
  };

  return (
    <>
      <div className="p-4 space-y-4">
        <div className="bg-[#F7F6F2] rounded-3xl">
          <div className="flex justify-between items-center w-full  p-4">
            <div className="flex justify-between items-center  rounded-tl-3xl rounded-tr-3xl">
              <h1 className="text-3xl text-[#212121]">Line Haul Companies</h1>
            </div>
            <div className=" flex items-center gap-2 justify-end rounded-full">
              <div className="flex items-center gap-2">
                <ColumnsFilter columnsData={[]} />
                <DropdownFilter filterheadings={[]} />
                <NormalSearch />
              </div>
              <button className="p-2 text-sm rounded-full border border-[#D8D8D8] bg-white">
                <IconDownload stroke={1.5}  size={20}/>
              </button>
              <button
                onClick={openShelveToggleModal}
                className="flex items-center gap-1  p-2 text-sm rounded-full border border-[#D8D8D8] bg-white"
              >
                <IconPlus stroke={1.5} size={20}/>
              </button>
            </div>
          </div>
          <div>
            {" "}
            <ListView
              data={lineHaulCompany}
              onRowClick={(client) => console.log("Clicked:", client)}
              columns={[
                { label: "#", render: (_, i) => i + 1 },
                {
                  label: "Company Name",
                  render: (c) => c.companyName,
                },
                {
                  label: "Contact",
                  render: (c) => c.contact,
                },
                { label: "Email", render: (c) => c.email },
                {
                  label: "Address",
                  render: (c) => c.address,
                },
                { label: "Date", render: (c) => c.date },
                {
                  label: "Status",
                  render: (c: any) => <ToggleButton />,
                },
                {
                  label: "Actions",
                  render: () => (
                    <div className="flex items-center gap-1">
                      <button className="p-2 border rounded-full bg-[#F7F6F2]">
                        <IconEye size={18} />
                      </button>
                      <button
                        onClick={sendRequestToggleModal}
                        className="p-2 border rounded-full bg-[#F7F6F2]"
                      >
                        <IconSend size={18} />
                      </button>
                    </div>
                  ),
                },
              ]}
            />
          </div>
        </div>
      </div>
      <CommonModal
        title={"Add Company"}
        open={openShelve}
        closeButtonText={"Cancel"}
        onClose={openShelveToggleModal}
        actionButtonText="Add"
        actionButtonOnClick={openShelveToggleModal}
      >
        <AddCompanyModal />
      </CommonModal>
      <CommonModal
        title={"Create New Request"}
        open={sendRequest}
        closeButtonText={"Cancel"}
        onClose={sendRequestToggleModal}
        actionButtonText="Send"
        actionButtonOnClick={sendRequestToggleModal}
      >
        <RequestSendModal />
      </CommonModal>
    </>
  );
};

export default LineHaulCompanies;
